import { Pipe, PipeTransform } from '@angular/core';
import { SgDocTitle } from './doc-title.service';

/**
 * Returns the same string value it gets but set value as the document title.
 */
@Pipe({
  name: 'sgDocTitle',
  standalone: false,
})
export class SgDocTitlePipe implements PipeTransform {
  constructor(private titleService: SgDocTitle) {}

  transform(value: string): string {
    this.titleService.setTitle(value || '');
    return value;
  }
}
